import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./SupervisedPage.css";
import { apiRequest, logout } from "../utils/api";

function SupervisedLearning() {
    const [columns, setColumns] = useState([]);
    const [targetVariable, setTargetVariable] = useState("");
    const [loading, setLoading] = useState(false);
    const [time, setTime] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        fetchColumns();
        const interval = setInterval(() => {
            const currentTime = new Date();
            const hours = currentTime.getHours() % 12 || 12;
            const minutes = currentTime.getMinutes().toString().padStart(2, "0");
            const seconds = currentTime.getSeconds().toString().padStart(2, "0");
            const ampm = currentTime.getHours() >= 12 ? "PM" : "AM";
            setTime(`${hours}:${minutes}:${seconds} ${ampm}`);
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    const handleLogout = async () => {
        try {
            await logout();
            navigate('/login');
        } catch (error) {
            console.error('Logout error:', error);
            navigate('/login');
        }
    };

    const fetchColumns = async () => {
        setLoading(true);
        try {
            const data = await apiRequest("/api/dataset/columns");
            if (data.status === "success") {
                setColumns(data.columns);
            } else {
                console.error("Error fetching columns:", data.message);
            }
        } catch (error) {
            console.error("Error fetching columns:", error);
        }
        setLoading(false);
    };

    const handleSelectTarget = (column) => {
        setTargetVariable(column);
        localStorage.setItem("selectedTarget", column);
        navigate("/algorithm-selection");
    };

    return (
        <div className="supervised-learning">
            {/* Top Navigation Bar */}
            <div className="top-nav">
                <div className="nav-content">
                    <div className="nav-left-group">
                        <div className="nav-logo" onClick={() => navigate("/")} style={{ cursor: "pointer" }}>
                            <img src="/HDASLogo.png" alt="HDAS" style={{ height: "80px", width: "auto" }} />
                        </div>
                        <button className="back-nav-button" onClick={() => navigate("/analysis-selection")}>
                            Analysis Selection
                        </button>
                    </div>
                    <div className="nav-right">
                        <div className="digital-clock">{time}</div>
                        <button onClick={handleLogout} className="logout-button">Logout</button>
                    </div>
                </div>
            </div>

            {/* Header Section */}
            <div className="page-header">
                <div className="header-content">
                    <h1>Supervised Learning</h1>
                    <p className="header-subtitle">Select the target variable you want to predict or classify</p>
                </div>
            </div>

            {/* Main Content */}
            <div className="page-content">
                <div className="info-box">
                    <h3>What is a Target Variable?</h3>
                    <p>The target variable is the outcome you want to predict. For example, if you're predicting patient readmission, "readmission_status" would be your target variable.</p>
                </div>

                {loading ? (
                    <div className="loading-container">
                        <div className="loading-spinner"></div>
                        <p>Loading columns...</p>
                    </div>
                ) : columns.length === 0 ? (
                    <div className="empty-state">
                        <p>No columns available. Please upload a dataset first.</p>
                        <button onClick={() => navigate("/auto-ml")} className="primary-button">
                            Upload Dataset
                        </button>
                    </div>
                ) : (
                    <>
                        <h2 className="section-title">Select Your Target Variable</h2>
                        <div className="target-selection">
                            {columns.map((column, index) => (
                                <div
                                    key={index}
                                    className={`target-box ${targetVariable === column ? "selected" : ""}`}
                                    onClick={() => handleSelectTarget(column)}
                                >
                                    <div className="target-box-icon"></div>
                                    <span className="target-box-text">{column}</span>
                                </div>
                            ))}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

export default SupervisedLearning;
